import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconFileCheck = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z' />
      <path d='M14 2v6h6' />
      <path d='m9 15 2 2 4-4' />
    </g>
  </SDIcon>
)

export default IconFileCheck
